import styled, { css } from "styled-components";
import { Row, Col } from "antd";
import TodoTemplateList from "components/todo/template/list";
import DatelineTemplateList from "components/job/dateline/template/list";

const LoadFromTemplate = (props) => {
  return (
    <>
      <StyledChildRow gutter={4}>
        <Col span={24}>
          <StyledContainer>
            {props.todo ? (
              <TodoTemplateList
                selectable
                handleSelectTodoTemplate={props.handleSelectTemplate}
              />
            ) : (
              <DatelineTemplateList
                selectable
                handleSelectDatelineTemplate={props.handleSelectTemplate}
              />
            )}
          </StyledContainer>
        </Col>
      </StyledChildRow>
    </>
  );
};

const StyledChildRow = styled(Row)`
  background-color: ${(props) => props.theme.colors.white};

  ${(props) =>
    props.$newJob &&
    css`
      padding: ${(props) => props.theme.spacing[4]};
    `};
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: auto;
`;

export default LoadFromTemplate;
